import Footer from '../components/layout/Footer';
import Header from '../components/layout/Header';
import Sidebar from '../components/layout/Sidebar';
import ToolWorkspace from '../components/tools/ToolWorkspace';
import { TOOL_DEFINITIONS } from '../modules/tools';

const ToolsPage = ({
  darkMode,
  selectedToolId,
  searchTerm,
  favorites,
  expandedCategories,
  filteredTools,
  categorizedTools,
  activeCategory,
  selectedTool,
  onToggleFavorite,
  handleCategorySelect,
  handleToggleCategory,
  onSearchTermChange,
  onToggleDarkMode,
  setSelectedToolId,
}) => {
  return (
    <div className="flex min-h-screen flex-col bg-slate-100 text-slate-900 transition-colors duration-200 dark:bg-slate-950 dark:text-slate-100">
      <Header
        activeCategory={activeCategory}
        onCategorySelect={handleCategorySelect}
        searchTerm={searchTerm}
        onSearchTermChange={onSearchTermChange}
        darkMode={darkMode}
        onToggleDarkMode={onToggleDarkMode}
      />

      <main className="mx-auto flex w-full max-w-7xl flex-1 flex-col gap-6 px-6 py-6 lg:flex-row">
        <Sidebar
          tools={filteredTools}
          allTools={TOOL_DEFINITIONS}
          groupedTools={categorizedTools}
          favorites={favorites}
          onToggleFavorite={onToggleFavorite}
          selectedToolId={selectedToolId}
          onSelectTool={setSelectedToolId}
          expandedCategories={expandedCategories}
          onToggleCategory={handleToggleCategory}
        />

        <section className="flex-1">
          <ToolWorkspace tool={selectedTool} />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ToolsPage;
